/* eslint-disable */
export default {
  title: '地域',
  NAOnlyMessage: '市外局番を設定してください。これは、国内通話に使用されます。',
  MultiWithNAMessage:
    'お客様の地域の国および市外局番を設定してください。これは、国内通話および電話番号の形式に使用されます。',
  MultiWithoutNAMessage:
    'お住まいの国を選択してください。これは、国内通話および電話番号の形式に使用されます。',
  country: '国',
  areaCode: '市外局番',
  areaCodePlaceholder: '市外局番の入力',
} as const;

// @key: @#@"title"@#@ @source: @#@"Region"@#@
// @key: @#@"NAOnlyMessage"@#@ @source: @#@"Please set your area code. This will be used for local dialing."@#@
// @key: @#@"MultiWithNAMessage"@#@ @source: @#@"Please set the country and area code for your region. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"MultiWithoutNAMessage"@#@ @source: @#@"Please select the country you locate in. This will be used for local dialing and phone number formatting."@#@
// @key: @#@"country"@#@ @source: @#@"Country"@#@
// @key: @#@"areaCode"@#@ @source: @#@"Area Code"@#@
// @key: @#@"areaCodePlaceholder"@#@ @source: @#@"Enter Area Code"@#@
